import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { EcaSecurityService, EcaSetupConfigurationService, SetupConfigAttribute } from '@drc-eca/eca-components-lib';
import { combineLatest, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReturnUrlGuard  {

  constructor(
    private router: Router,
    private ecaSecurityService: EcaSecurityService,
    private setupConfigService: EcaSetupConfigurationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkReturnUrl(state.url);
  }

  checkReturnUrl(url: string): Observable<boolean> {
    if (url.includes('returnUrl=')) {
      const returnUrl = url.split('returnUrl=')[1];

      // No javascript, mailto, file, or multiple returnUrls
      const hasExecutable = returnUrl.includes('javascript')
        || returnUrl.includes('mailto')
        || returnUrl.includes('file:')
        || returnUrl.includes('file%3A')
        || url.lastIndexOf('returnUrl=') != url.indexOf('returnUrl=');

      const allowedReturnDomains = this.setupConfigService.getAttributesForClient('DRCPORTAL').pipe(
        map(attributes => {
          let allowedReturnDomains: string[];
          for (const attribute of attributes) {
            if (attribute.attribute.key === 'portal-allowed-return-domains') {
              allowedReturnDomains = attribute.value?.allowed || attribute.attribute.defaultValue?.allowed;
              break;
            }
          }
          return allowedReturnDomains;
        })
      );

      const domainAllowed = allowedReturnDomains.pipe(
        map(domains => {
          return domains.some(domain => returnUrl.includes(domain));
        })
      );

      return combineLatest([of(hasExecutable), domainAllowed]).pipe(
        map(([a, b]) => {
          const isValidReturnUrl = !a && b;
          if (isValidReturnUrl) {
            return true;
          } else {
            this.router.navigate(['/error/403', { queryParams: { desc: 'The returnUrl parameter provided is invalid.' } }]);
            return false;
          }
        })
      );
    }
    return of(true);
  }
}
